module.exports = __webpack_public_path__ + "img/arrow-download.5d048d2a.svg";